import {
  Flex,
} from '@chakra-ui/react';
import { useConfig } from '@src/context/config';
import {
  SideNavigation, MainHeader, currentDatabaseSelector, selectedLockYearState, MainFooter, HEADER_HEIGHT,
} from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';

export default function MainLayout({
  showSidebar = true, children, ...other
}) {
  const db = useRecoilValue(currentDatabaseSelector);
  const lockYear = useRecoilValue(selectedLockYearState);
  const dbString = db?.id ? db.id.toString() : null;
  const { LEGACY_PMRT_URL, SETTINGS_API_URL } = useConfig();

  // Set global apex chart options
  window.Apex = window.Apex || {};

  window.Apex.chart = {
    fontFamily: 'Arial, sans-serif',
    toolbar: {
      show: true,
      tools: {
        download: true,
      },
      export: {
        scale: 4,
      },
    },
    zoom: {
      enabled: false,
    },
    legend: {
      markers: {
        size: 1,
      },
      floating: false,
      offsetY: 5,
      itemMargin: {
        vertical: 0,
      },
    },
    animations: { enabled: false },
  };

  window.Apex.stroke = {
    curve: 'straight',
    width: 2,
  };

  window.Apex.markers = {
    size: 3,
    strokeWidth: 1,
    hover: {
      size: 6,
    },
  };

  window.Apex.legend = {
    show: true,
    floating: false,
    offsetY: 5,
    clusterGroupedSeries: false,
    itemMargin: {
      vertical: 0,
    },
    markers: {
      size: 4,
    },
  };

  window.Apex.noData = {
    text: 'No Data',
    align: 'center',
    verticalAlign: 'middle',
    style: {
      fontSize: '16px',
    },
  };

  window.Apex.title = {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#4a4453',
    },
  };

  window.Apex.yaxis = {
    title: {
      style: {
        fontWeight: 'normal',
      },
    },
  };

  window.Apex.xaxis = {
    labels: {
      style: {
        fontWeight: 'normal',
        fontSize: '11px',
      },
      tickPlacement: 'on',
      hideOverlappingLabels: false,
    },
  };

  return (
    <>
      <MainHeader pmrtLegacyUrl={LEGACY_PMRT_URL} settingsApiUrl={SETTINGS_API_URL} loginUrl={process.env.REACT_APP_LOGIN_PATH} />
      <Flex
        minHeight={`calc(100vh - ${HEADER_HEIGHT})`}
      >
        {showSidebar && (
          <SideNavigation
            db={dbString}
            lockYear={lockYear}
            reactRouterApps={['reg-insights', 'tce']}
          />
        )}
        <Flex
          flexDir="column"
          flex="1"
          minWidth="0"
        >
          <Flex
            as="main"
            role="main"
            flexGrow="1"
            flexDirection="column"
            backgroundColor="gray.50"
            py={4}
            minWidth="0"
            {...other}
          >
            { children }
          </Flex>
          <MainFooter />
        </Flex>
      </Flex>
    </>
  );
}
